import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';
import {
  fetchGetNewbuildingJsonQuery,
  IGetNewbuildingJsonQueryResponse,
  IGetNewbuildingJsonQueryResponse200,
  IGetNewbuildingJsonQueryResponse400,
} from '../../repositories/newbuilding-search/v2/get-newbuilding-json-query';
import { assertNotFoundError } from './assertNotFoundError';
import { assertBadStatusCodeError } from './assertBadStatusCodeError';

export async function resolveNewbuildingJsonQuery(
  subdomain: string,
  path: string,
  logger: ILogger,
  httpApi: IHttpApi,
): Promise<IGetNewbuildingJsonQueryResponse> {
  try {
    const getJsonQueryResponse = await fetchGetNewbuildingJsonQuery<
      IGetNewbuildingJsonQueryResponse200,
      IGetNewbuildingJsonQueryResponse400
    >({ httpApi, parameters: { subdomain, path } });

    assertNotFoundError(getJsonQueryResponse);
    assertBadStatusCodeError(getJsonQueryResponse);

    return (getJsonQueryResponse as IGetNewbuildingJsonQueryResponse200).response;
  } catch (err) {
    logger.warning(err, {
      message: err.message,
      stack: err.stack,
      comment: 'Error in resolveNewbuildingJsonQuery',
    });

    throw err;
  }
}
